import { render, staticRenderFns } from "./tts.vue?vue&type=template&id=5c68804a&scoped=true&"
import script from "./tts.vue?vue&type=script&lang=js&"
export * from "./tts.vue?vue&type=script&lang=js&"
import style0 from "./tts.vue?vue&type=style&index=0&id=5c68804a&prod&scoped=true&lang=css&"
import style1 from "./tts.vue?vue&type=style&index=1&id=5c68804a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c68804a",
  null
  
)

export default component.exports